import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as clicksAPi from "../api/clicksApi";
import { message } from "antd";

const initialState = {
  //store data
  campaignData: [],
  unknownUserData: [],
  campUrlsData: [],
  siteIdData: [],
  codeTypeData: [],
  // responseCSVData: [],
  activePartners: [],
  clicksReportData: [],
  totalClicksData: [],
  conversionReportData: [],
  totalConversionData: [],
  partnerReportData: [],
  totalpartnerReportData: [],
  filterData: [],
  responseCSV: [],
  campGraphResult: [],
  networkFilterData: [],
  loginIdFilterData: [],
  campFilterData: [],
  campTableData: [],
  networkTableData: [],
  performSiteData: [],
  siteGraphData: [],
  siteTableData: [],
  cronLogStats: { data: { hourly: [], daily: [] }, filter_data: [] },
  // total_camp_count: 0,
  // total_network_count: 0,
  //common data
  loading: false,
  error: "",
  success: "",
};

//=================================getCampaign data using asyncthunk=====================================

export const getCampaign = createAsyncThunk(
  "clicks/getcampaign",
  async (_, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getCampaignApi();
      if (resp.data.code === 200) {
        return resp.data.data;
      } else {
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const addCampaignMasterData = createAsyncThunk(
  "clicks/addcampaign",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.addCampaignMasterDataApi(formData);
      if (resp.data.code === 200) {
        message.success(
          resp.data.message ? resp.data.message : "Campaign added successfully"
        );
        return resp.data.message;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "Campaign not added"
        );
        return rejectWithValue(resp.data.message);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const updateCampaignMasterDataApi = createAsyncThunk(
  "/clicks/updatecampaign",
  async (formData, { rejectWithValue }) => {
    try {
      //   console.log(formData, "formData===========>");
      const resp = await clicksAPi.updateCampaignMasterDataApi(formData);
      if (resp.data.code === 200) {
        message.success(
          resp.data.message ? resp.data.message : "Campaign updated"
        );
        return resp.data.message;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "Campaign not updated"
        );
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

////====================== Unknown User Data Routes ====================//

export const getUnknownUserData = createAsyncThunk(
  "clicks/getunknownuser",
  async (_, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getUnknownUserDataApi();
      if (resp.data.code === 200) {
        return resp.data.data;
      } else {
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const addunknownuser = createAsyncThunk(
  "clicks/addunknownuser",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.addunknownuserApi(formData);
      if (resp.data.code === 200) {
        message.success(
          resp.data.message
            ? resp.data.message
            : "Unknown User Data added successfully"
        );
        return resp.data.message;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "Unknown User Data not added"
        );
        return rejectWithValue(resp.data.message);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const updateUnknownUserData = createAsyncThunk(
  "clicks/updateunknownuser",
  async (formData, { rejectWithValue }) => {
    try {
      //   console.log(formData, "formData===========>");
      const resp = await clicksAPi.updateUnknownUserDataApi(formData);
      if (resp.data.code === 200) {
        message.success(
          resp.data.message ? resp.data.message : "Campaign updated"
        );
        return resp.data.message;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "Campaign not updated"
        );
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

////====================== Campaign Urls Data Routes ====================//

export const getCampUrls = createAsyncThunk(
  "clicks/getcampurls",
  async (_, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getCampUrlsApi();
      if (resp.data.code === 200) {
        return resp.data.data;
      } else {
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const addCampUrls = createAsyncThunk(
  "clicks/addcampurls",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.addCampUrlsApi(formData);
      if (resp.data.code === 200) {
        message.success(
          resp.data.message ? resp.data.message : "camp url added successfully"
        );
        return resp.data.message;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "camp url not added"
        );
        return rejectWithValue(resp.data.message);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const updateCampUrls = createAsyncThunk(
  "clicks/updatecampurls",
  async (formData, { rejectWithValue }) => {
    try {
      //   console.log(formData, "formData===========>");
      const resp = await clicksAPi.updateCampUrlsApi(formData);
      if (resp.data.code === 200) {
        message.success(
          resp.data.message ? resp.data.message : "camp url updated"
        );
        return resp.data.message;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "camp url not updated"
        );
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

////======================getCodeType Data Routes ====================//

export const getCodeType = createAsyncThunk(
  "clicks/getcodetype",
  async (_, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getCodeTypeApi();
      if (resp.data.code === 200) {
        return resp.data.data;
      } else {
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const updateCodeType = createAsyncThunk(
  "clicks/updateCodeType",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.updateCodeTypeApi(formData);
      if (resp.data.code === 200) {
        return resp.data;
      } else {
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getCountriesExcept = createAsyncThunk(
  "clicks/getCountriesExcept",
  async (_, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getCountriesExceptApi();
      if (resp.data.code === 200) return resp.data.data;
      return rejectWithValue(resp.data);
    } catch (error) { return rejectWithValue(error.response?.data || error.message); }
  }
);

export const addCountriesExcept = createAsyncThunk(
  "clicks/addCountriesExcept",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.addCountriesExceptApi(formData);
      if (resp.data.code === 200) return resp.data;
      return rejectWithValue(resp.data);
    } catch (error) { return rejectWithValue(error.response?.data || error.message); }
  }
);

export const updateCountriesExcept = createAsyncThunk(
  "clicks/updateCountriesExcept",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.updateCountriesExceptApi(formData);
      if (resp.data.code === 200) return resp.data;
      return rejectWithValue(resp.data);
    } catch (error) { return rejectWithValue(error.response?.data || error.message); }
  }
);

// ========================= Cron Resolver Config =========================
export const getCronResolverConfigs = createAsyncThunk(
  "clicks/getCronResolverConfigs",
  async (_, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getCronResolverConfigsApi();
      if (resp.data.code === 200) return resp.data.data;
      return rejectWithValue(resp.data);
    } catch (error) { return rejectWithValue(error.response?.data || error.message); }
  }
);

export const addCronResolverConfig = createAsyncThunk(
  "clicks/addCronResolverConfig",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.addCronResolverConfigApi(formData);
      if (resp.data.code === 200) return resp.data;
      return rejectWithValue(resp.data);
    } catch (error) { return rejectWithValue(error.response?.data || error.message); }
  }
);

export const updateCronResolverConfig = createAsyncThunk(
  "clicks/updateCronResolverConfig",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.updateCronResolverConfigApi(formData);
      if (resp.data.code === 200) return resp.data;
      return rejectWithValue(resp.data);
    } catch (error) { return rejectWithValue(error.response?.data || error.message); }
  }
);

export const deleteCronResolverConfig = createAsyncThunk(
  "clicks/deleteCronResolverConfig",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.deleteCronResolverConfigApi(formData);
      if (resp.data.code === 200) return resp.data;
      return rejectWithValue(resp.data);
    } catch (error) { return rejectWithValue(error.response?.data || error.message); }
  }
);

////====================== getSiteId Data Routes ====================//

export const getSiteId = createAsyncThunk(
  "clicks/getsiteid",
  async (_, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getSiteIdApi();
      if (resp.data.code === 200) {
        return resp.data.data;
      } else {
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const getClicksReportData = createAsyncThunk(
  "clicks/clicksreport",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getClicksReportDataApi(formData);
      if (resp.data.code === 200) {
        return resp.data;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "not get the report"
        );
        return rejectWithValue(resp.data.message);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const getConversionReportData = createAsyncThunk(
  "clicks/getconveriosnreport",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getConversionReportDataApi(formData);
      if (resp.data.code === 200) {
        return resp.data;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "not get the report"
        );
        return rejectWithValue(resp.data.message);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const uploadCSV = createAsyncThunk(
  "clicks/uploadcsv",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.uploadCSVApi(formData);
      if (resp.data.code === 200) {
        message.success(
          resp.data.message ? resp.data.message : "Uploaded Successfully!"
        );
      } else {
        message.error(resp.data.message ? resp.data.message : "not updated");
        return rejectWithValue(resp.data.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const uploadCampaignCSV = createAsyncThunk(
  "clicks/uploadcampcsv",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.uploadCampCSVApi(formData);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);


export const getFilterDataCampaign = createAsyncThunk(
  "clicks/getcampgraphfilterdata",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getFilterDataCampaignApi(formData);
      if (resp.data.code === 200) {
        return resp.data.data;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "camp filter not found"
        );
        return rejectWithValue(resp.data.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const getCampGraphResult = createAsyncThunk(
  "clicks/getcampgraphreport",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getCampGraphResultApi(formData);
      // console.log(resp, "resp");
      if (resp.data.code === 200) {
        if (!resp.data.data[0].graph_data)
          return {
            date: [],
            total_approved: [],
            total_cancelled: [],
            total_clicks: [],
            total_conversion: [],
            total_pending: [],
            total_approved_conversion: [],
            total_cancelled_conversion: [],
            total_state: { sum_clicks: 0, sum_conversions: 0, sum_pending: 0,sum_cancelled_conversion:0,sum_approved_conversion:0 ,sum_approved:0,sum_cancelled:0 },
          };
        const parsedData = JSON.parse(resp.data.data[0].graph_data);
        const result = {
          date: [],
          total_approved: [],
          total_cancelled: [],
          total_clicks: [],
          total_conversion: [],
          total_pending: [],
          total_approved_conversion: [],
          total_cancelled_conversion: [],
          total_state: { sum_clicks: 0, sum_conversions: 0, sum_pending: 0,sum_cancelled_conversion:0,sum_approved_conversion:0 ,sum_approved:0,sum_cancelled:0 },
        };
        parsedData.map((element, index) => {
          // console.log(
          //   typeof element.total_clicks,
          //   "clickes",
          //   element.total_clicks
          // );
          if (element.total_clicks) {
            result.total_state.sum_clicks += element.total_clicks;
          }
          if (element.total_conversion) {
            result.total_state.sum_conversions += element.total_conversion;
          }
          if (element.total_pending) {
            result.total_state.sum_pending += element.total_pending;
          }
          if (element.total_cancelled_conversion) {
            result.total_state.sum_cancelled_conversion += element.total_cancelled_conversion;
          }
          if (element.total_approved_conversion) {
            result.total_state.sum_approved_conversion += element.total_approved_conversion;
          }
          if(element.total_cancelled){
            result.total_state.sum_cancelled += element.total_cancelled;
          }
          if(element.total_approved){
            result.total_state.sum_approved += element.total_approved;
          }
          result.date.push(element.date);
          result.total_approved.push(element.total_approved);
          result.total_cancelled.push(element.total_cancelled);
          result.total_clicks.push(element.total_clicks);
          result.total_conversion.push(element.total_conversion);
          result.total_pending.push(element.total_pending);
          result.total_approved_conversion.push(element.total_approved_conversion);
          result.total_cancelled_conversion.push(element.total_cancelled_conversion);
        });

        // console.log(result, "result");

        return result;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "camp url not added"
        );
        return rejectWithValue(resp.data.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const getPerformanceSitesGraphData = createAsyncThunk(
  "clicks/getperformancegraphdata",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getPerformanceSitesGraphDataApi(formData);
      if (resp.data.code === 200) {
        if (!resp.data.data[0].graph_data)
          return { date: [], total_counts: [], total_users: [] };
        const parsedData = JSON.parse(resp.data.data[0].graph_data);
        const result = {
          date: [],
          total_counts: [],
          total_users: [],
        };
        parsedData.map((element, index) => {
          result.date.push(element.created_date);
          result.total_counts.push(element.total_counts);
          result.total_users.push(element.total_users);
        });
        // console.log(result, "result");
        return result;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "camp url not added"
        );
        return rejectWithValue(resp.data.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const getCampaignTableDetails = createAsyncThunk(
  "clicks/getcamptabledata",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getCampaignTableDetailsApi(formData);
      if (resp.data.code === 200) {
        return resp.data;
      } else {
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const getNetworkTableDetails = createAsyncThunk(
  "clicks/getnetworktabledata",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getNetworkTableDetailsApi(formData);
      if (resp.data.code === 200) {
        return resp.data;
      } else {
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const performanceSitesData = createAsyncThunk(
  "clicks/perfromsitefilterdata",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.performanceSitesDataApi(formData);
      if (resp.data.code === 200) {
        return resp.data.data;
      } else {
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const getSitesTableDetails = createAsyncThunk(
  "clicks/getsitetabledata",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getSitesTableDetailsApi(formData);
      if (resp.data.code === 200) {
        return resp.data;
      } else {
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const getPartnerDetails = createAsyncThunk(
  "clicks/allpartnerdetail",
  async (_, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getPartnerDetailsApi();
      if (resp.data.code === 200) {
        return resp.data.data;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "camp url not added"
        );
        return rejectWithValue(resp.data.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const getPartnerresponseData = createAsyncThunk(
  "clicks/getpartnerresponse",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getPartnerresponseDataApi(formData);
      if (resp.data.code === 200) {
        return resp.data;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "camp url not added"
        );
        return rejectWithValue(resp.data.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const getResponseMasterDataCSV = createAsyncThunk(
  "/clicks/responsemastercsv",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getResponseMasterDataCSVApi(formData);
      if (resp.data.code === 200) {
        return resp.data.data;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "Something went Wrong!"
        );
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const getFiilterResponseData = createAsyncThunk(
  "/clicks/getfilterresult",
  async (formData, { rejectWithValue }) => {
    try {
      // console.log(formData, "formData");
      const resp = await clicksAPi.getFilterData(formData);
      if (resp.data.code === 200) {
        return resp.data.data;
      } else {
        message.error(
          resp.data.message ? resp.data.message : "Something went Wrong!"
        );
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      rejectWithValue(error.resp.data);
    }
  }
);

export const getCronLogStats = createAsyncThunk(
  "clicks/getcampcronlogs",
  async (formData, { rejectWithValue }) => {
    try {
      const resp = await clicksAPi.getCronLogsApi(formData);
      if (resp.data.code === 200) {
        return resp.data;
      } else {
        return rejectWithValue(resp.data);
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


const clicksSlice = createSlice({
  name: "clicks",
  initialState,
  reducers: {
    // setStoreCategories: (state, action) => {
    //   state.storeCategories = action.payload;
    // },
  },

  extraReducers: (builder) => {
    ///=================================getCampaign data===========================//////////////////////

    builder.addCase(getCampaign.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCampaign.fulfilled, (state, action) => {
      // state.loading = false;
      state.campaignData = action.payload;
    });
    builder.addCase(getCampaign.rejected, (state, action) => {
      state.error = action.payload;
    });

    // ===================================updateCampaignMasterDataApi===========
    builder.addCase(updateCampaignMasterDataApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCampaignMasterDataApi.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateCampaignMasterDataApi.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=======================addCampaignMasterData data===========================//////////////////

    builder.addCase(addCampaignMasterData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addCampaignMasterData.fulfilled, (state, action) => {
      // state.loading = false;
      state.success = action.payload;
    });
    builder.addCase(addCampaignMasterData.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================getUnknownUserData data===========================//////////////////////

    builder.addCase(getUnknownUserData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUnknownUserData.fulfilled, (state, action) => {
      // state.loading = false;
      state.unknownUserData = action.payload;
    });
    builder.addCase(getUnknownUserData.rejected, (state, action) => {
      state.error = action.payload;
    });

    // ===================================updateUnknownUserData===========
    builder.addCase(updateUnknownUserData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateUnknownUserData.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateUnknownUserData.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=======================addunknownuser data===========================//////////////////

    builder.addCase(addunknownuser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addunknownuser.fulfilled, (state, action) => {
      // state.loading = false;
      state.success = action.payload;
    });
    builder.addCase(addunknownuser.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================getCampUrls data===========================//////////////////////

    builder.addCase(getCampUrls.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCampUrls.fulfilled, (state, action) => {
      // state.loading = false;
      state.campUrlsData = action.payload;
    });
    builder.addCase(getCampUrls.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================getCampGraphResult data===========================//////////////////////

    builder.addCase(getCampGraphResult.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCampGraphResult.fulfilled, (state, action) => {
      // state.loading = false;
      state.campGraphResult = action.payload;
    });
    builder.addCase(getCampGraphResult.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================getCampaignTableDetails data===========================//////////////////////

    builder.addCase(getCampaignTableDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCampaignTableDetails.fulfilled, (state, action) => {
      // state.loading = false;
      state.campTableData = action.payload.data;
      // state.total_camp_count = action.payload.total_campaign_count;
    });
    builder.addCase(getCampaignTableDetails.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================getNetworkTableDetails data===========================//////////////////////

    builder.addCase(getNetworkTableDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getNetworkTableDetails.fulfilled, (state, action) => {
      // state.loading = false;

      state.networkTableData = action.payload.data;
      // state.total_network_count = action.payload.total_network_count;
    });
    builder.addCase(getNetworkTableDetails.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================performanceSitesData data===========================//////////////////////

    builder.addCase(performanceSitesData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(performanceSitesData.fulfilled, (state, action) => {
      // state.loading = false;

      state.performSiteData = action.payload;
    });
    builder.addCase(performanceSitesData.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================getSitesTableDetails data===========================//////////////////////

    builder.addCase(getSitesTableDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSitesTableDetails.fulfilled, (state, action) => {
      // state.loading = false;

      state.siteTableData = action.payload.data;
      // state.total_site_count = action.payload.total_site_count;
    });
    builder.addCase(getSitesTableDetails.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================getPerformanceSitesGraphData data===========================//////////////////////

    builder.addCase(getPerformanceSitesGraphData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPerformanceSitesGraphData.fulfilled, (state, action) => {
      // state.loading = false;

      state.siteGraphData = action.payload;
    });
    builder.addCase(getPerformanceSitesGraphData.rejected, (state, action) => {
      state.error = action.payload;
    });
    ///=================================getFilterDataCampaign data===========================//////////////////////

    builder.addCase(getFilterDataCampaign.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFilterDataCampaign.fulfilled, (state, action) => {
      // state.loading = false;
      state.campFilterData = action.payload.campaign;
      state.networkFilterData = action.payload.network;
      state.loginIdFilterData = action.payload.login_ids;
    });
    builder.addCase(getFilterDataCampaign.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================getCronLogStats data===========================//////////////////////
    builder.addCase(getCronLogStats.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCronLogStats.fulfilled, (state, action) => {
      state.loading = false;
      state.cronLogStats = action.payload;
    });
    builder.addCase(getCronLogStats.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // ===================================updateCampUrls===========
    builder.addCase(updateCampUrls.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateCampUrls.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateCampUrls.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=======================addCampUrls data===========================//////////////////

    builder.addCase(addCampUrls.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addCampUrls.fulfilled, (state, action) => {
      // state.loading = false;
      state.success = action.payload;
    });
    builder.addCase(addCampUrls.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================getCodeType data===========================//////////////////////

    builder.addCase(getCodeType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCodeType.fulfilled, (state, action) => {
      // state.loading = false;
      state.codeTypeData = action.payload;
    });
    builder.addCase(getCodeType.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================getSiteId data===========================//////////////////////

    builder.addCase(getSiteId.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSiteId.fulfilled, (state, action) => {
      // state.loading = false;
      state.siteIdData = action.payload;
    });
    builder.addCase(getSiteId.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///========================getPartnerresponseData data=====================////////////////

    builder.addCase(getPartnerresponseData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPartnerresponseData.fulfilled, (state, action) => {
      state.loading = false;
      state.partnerReportData = action.payload.data;
      state.totalpartnerReportData = action.payload.total_results;
    });
    builder.addCase(getPartnerresponseData.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================getPartnerDetails data===========================//////////////////////

    builder.addCase(getPartnerDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPartnerDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.activePartners = action.payload;
    });
    builder.addCase(getPartnerDetails.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================uploadCSV data===========================//////////////////////

    builder.addCase(uploadCSV.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(uploadCSV.fulfilled, (state, action) => {
      state.loading = false;
      state.responseCSVData = action.payload;
    });
    builder.addCase(uploadCSV.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================uploadCampaignCSV data===========================//////////////////////

    builder.addCase(uploadCampaignCSV.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(uploadCampaignCSV.fulfilled, (state, action) => {
      state.loading = false;
      // state.responseCSVData = action.payload;
    });
    builder.addCase(uploadCampaignCSV.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================getClicksReportData data===========================//////////////////////

    builder.addCase(getClicksReportData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getClicksReportData.fulfilled, (state, action) => {
      state.loading = false;
      state.clicksReportData = action.payload.data;
      state.totalClicksData = action.payload.total_results;
    });
    builder.addCase(getClicksReportData.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================getConversionReportData data===========================//////////////////////

    builder.addCase(getConversionReportData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getConversionReportData.fulfilled, (state, action) => {
      state.loading = false;
      state.conversionReportData = action.payload.data;
      state.totalConversionData = action.payload.total_no_points;
    });
    builder.addCase(getConversionReportData.rejected, (state, action) => {
      state.error = action.payload;
    });

    ///=================================getFilterData data===========================//////////////////////

    builder.addCase(getFiilterResponseData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFiilterResponseData.fulfilled, (state, action) => {
      state.loading = false;
      state.filterData = action.payload;
    });
    builder.addCase(getFiilterResponseData.rejected, (state, action) => {
      state.error = action.payload;
    });

    // ==============================================================================================
    builder.addCase(getResponseMasterDataCSV.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getResponseMasterDataCSV.fulfilled, (state, action) => {
      state.responseCSV = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getResponseMasterDataCSV.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});
// export const { setStoreCategories } = clicksSlice.actions;
export default clicksSlice.reducer;
